import { useEffect, useState } from 'react';
import { H4, Body3 } from '../../../themes/typography';
import './loadingVerification.css';

const VerifyingLoader = () => {
    const [dots, setDots] = useState('');
    const [message, setMessage] = useState('Verifying your account');
    const [timeElapsed, setTimeElapsed] = useState(0);

    // Animated dots effect
    useEffect(() => {
        const dotInterval = setInterval(() => {
            setDots((prevDots) => {
                if (prevDots.length >= 3) return '';
                return prevDots + '.';
            });
        }, 500);

        return () => clearInterval(dotInterval);
    }, []);

    // Change message if verification takes too long
    useEffect(() => {
        const timer = setInterval(() => {
            setTimeElapsed((prev) => prev + 1);
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    // Update message based on time elapsed
    useEffect(() => {
        if (timeElapsed > 10) {
            setMessage('Still verifying your account');
        }
        if (timeElapsed > 20) {
            setMessage('This is taking longer than expected');
        }
    }, [timeElapsed]);

    return (
        <div className="loading-container">
            <div className="loading-content">
                <div className="spinner-container">
                    <div className="spinner">
                        <div className="spinner-inner"></div>
                    </div>
                </div>

                <h1 className="loading-title">
                    <H4 color="var(--secondary-color)">{message}</H4>
                    <span className="loading-dots">{dots}</span>
                </h1>

                <Body3 color="var(--tertiary-color)">
                    Please wait while we verify your credentials
                </Body3>

                {timeElapsed > 15 && (
                    <div className="loading-extended-message">
                        <Body3 color="var(--secondary-color)">
                            This may take a moment. Please don't close this window.
                        </Body3>
                    </div>
                )}
            </div>
        </div>
    );
};

export default VerifyingLoader;
